export const USER_REQUEST = 'USER_REQUEST';
export const USER_STATUS = 'USER_STATUS';
export const USER_REMOVE = 'USER_REMOVE';
